// import React, { useRef, useState } from "react";
import MainContainer from "../../components/MainContainer";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { appConfig } from "../../config";

const DummyLoginPage = () => {
	const { isAuth/*, login*/ } = useAuth();

	// const [username, setUsername] = useState("");
	// const [password, setPassword] = useState("");
	// const [error, setError] = useState("");

	//const usernameRef = useRef(null);

	if (isAuth) {
		return (
			<Navigate
				to={
					"/tickets-gov/confirmation"
				}
			/>
		);
	}

	// const handleSubmit = async (e) => {
	// 	e.preventDefault();
	// 	setError("");

	// 	try {
	// 		const response = await fetch("/api/dummy/auth/login", {
	// 			method: "POST",
	// 			headers: { "Content-Type": "application/json" },
	// 			body: JSON.stringify({ username, password }),
	// 			credentials: "include" // <--- πολύ σημαντικό για session
	// 		});

	// 		if (!response.ok) {
	// 			const message = await response.text();
	// 			setUsername('');
	// 			setPassword('');
	// 			usernameRef.current?.focus();
	// 			throw new Error(message);
	// 		}

	// 		// Μετά το login, παίρνουμε τα δεδομένα του χρήστη από /user
	// 		const userResponse = await fetch("/api/auth/user", {
	// 			credentials: "include"
	// 		});

	// 		if (!userResponse.ok) {
	// 			throw new Error("Σφάλμα κατά την ανάκτηση στοιχείων χρήστη");
	// 		}

	// 		const userData = await userResponse.json();


	// 		// Αποθήκευση στο context
	// 		login({
	// 			username: userData.username,
	// 			role: userData.role,
	// 			...userData
	// 		});
	// 	} catch (err) {
	// 		setError(err.message || "Σφάλμα κατά τη σύνδεση");
	// 	}
	// };
	return (
		<MainContainer>
			<div
				className="d-flex flex-column justify-content-center align-items-center"
				style={{ minHeight: '60vh' }}
			>
				<div className="mb-4 text-center">
					<h1 className="mb-2">Απαιτείται ταυτοποίηση</h1>
					<p>Για να προχωρήσετε, πρέπει πρώτα να συνδεθείτε.</p>
				</div>
				<div className="col-lg-4">
					{/* <div className="card p-4 shadow-sm">
						<h1 className="mb-4 text-center">Σύνδεση</h1>
						<form onSubmit={handleSubmit}>
							<div className="mb-3">
								<label className="form-label">Όνομα χρήστη</label>
								<input
									ref={usernameRef}
									type="text"
									className="form-control"
									value={username}
									onChange={(e) => setUsername(e.target.value)}
									required
								/>
							</div>
							<div className="mb-3">
								<label className="form-label">Κωδικός</label>
								<input
									type="password"
									className="form-control"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									required
								/>
							</div>
							{error && (
								<div className="alert alert-danger text-center">
									{error}
								</div>
							)}
							<button type="submit" className="btn btn-primary btn-lg w-100">
								Σύνδεση
							</button>
						</form>
					</div> */}
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<a
							href={`${appConfig.url}/oauth2/authorization/taxis-gov`}
							className="btn btn-primary btn-lg btn-login mt-4"
						>
							<svg
								className="MuiSvgIcon-root"
								focusable="false"
								viewBox="0 0 24 24"
								aria-hidden="true"
							>
								<path
									d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
							</svg>
							<span>Σύνδεση GSIS</span>
						</a>
					</div>
				</div>
			</div>
		</MainContainer>
	);
};

export default DummyLoginPage;
